var _style, _g, _circle, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyArchiveduser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 111.5 118",
    style: {
      enableBackground: "new 0 0 111.5 118"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9093A6;}\n\t.st1{fill:#C0C3CD;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.5,118c-1.1,0-2.1-0.4-2.8-1.2l-5.8-5.8c-3.6,2.5-8,3.9-12.4,3.9c-12.1,0-21.9-9.8-21.9-21.9 s9.8-21.9,21.9-21.9s21.9,9.8,21.9,21.9c0,4.4-1.3,8.8-3.9,12.4l5.8,5.8c0.7,0.7,1.2,1.7,1.2,2.8C111.5,116.2,109.6,118,107.5,118z  M86.5,79c-7.7,0-13.9,6.3-13.9,13.9s6.3,13.9,13.9,13.9s13.9-6.3,13.9-13.9S94.2,79,86.5,79z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 42.2,
    cy: 23.4,
    r: 23.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.5,66.2c-6.7-4.3-14.7-7.5-23.4-7.5C18.9,58.7,0,82.1,0,86.5c0,4.4,18.9,8,42.2,8c3.5,0,6.9-0.1,10.1-0.2 c0-0.4,0-0.7,0-1.1C52.3,82.2,57.5,72.4,65.5,66.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyArchiveduser);
export default __webpack_public_path__ + "static/media/empty-archiveduser.56ff30682e309065e083cb4268c81869.svg";
export { ForwardRef as ReactComponent };